import { Card, CardContent, Grid, Typography } from "@mui/material";
import { settings } from "app";
import {
  AddItemButton,
  ArrayInput,
  NumberInput,
  required,
  SelectInput,
  SimpleFormIterator,
  useSimpleFormIteratorItem,
} from "react-admin";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { ExamCommissionRoles } from "utils/choices";

const SessionProfessors = ({ disciplineId, defaultValue = [{ professors: [] }] }) => {
  const IndexField = () => {
    const { index } = useSimpleFormIteratorItem();
    return (
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          readOnly
          source="commissionNumber"
          label="Комисия #"
          defaultValue={index + 1}
        />
      </Grid>
    );
  };

  return (
    <Card sx={{ width: "100%", mb: 2, mt: 2 }}>
      <CardContent>
        <Grid
          container
          spacing={1}
        >
          <Typography
            fontWeight="bold"
            color="primary"
          >
            Преподаватели
          </Typography>
          <ArrayInput
            source="commissions"
            label=" "
            defaultValue={defaultValue}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              addButton={<AddItemButton label="Добави комисия" />}
              inline={false}
              sx={settings.style.iteratorWithoutGap}
            >
              <IndexField />

              <ArrayInput
                source="professors"
                label=" "
                defaultValue={[]}
              >
                <SimpleFormIterator
                  disableReordering
                  disableClear
                  addButton={<AddItemButton label="Добави преподавател" />}
                  inline
                  sx={settings.style.iteratorWithoutGap}
                >
                  <Grid
                    item
                    xs={12}
                    md={7}
                  >
                    <ProfessorInput
                      source="professorEmployeeId"
                      fullWidth
                      validate={required()}
                      filters={{ DisciplineId: disciplineId }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={3}
                  >
                    <SelectInput
                      source="role"
                      label="Роля"
                      choices={ExamCommissionRoles}
                      optionValue="id"
                      optionText="name"
                      validate={required()}
                    />
                  </Grid>
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SessionProfessors;
